import Vue from 'vue';
import i18n from '../plugins/i18n';

const statoPrestazione = (value?: number) => {
    if (!value) {
        return '';
    }
    return i18n.t('labels.stato-prestazione-' + value.toString());
}

Vue.filter('statoPrestazione', (value?: number) => {
    return statoPrestazione(value);
});
